import { render, staticRenderFns } from "./Opsiyon.vue?vue&type=template&id=ece43622&scoped=true&"
import script from "./Opsiyon.vue?vue&type=script&lang=js&"
export * from "./Opsiyon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece43622",
  null
  
)

export default component.exports